import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "./api"; // ✅ shared axios client

function RequestForm() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    date: "",
    line: "",
    machine: "",
    task: "",
    lead_time: "",
    assignee: "",
    scheduled_date: "",
    status: "pending", // optional (backend can ignore)
    type: "request",   // optional (backend can ignore)
  });

  const [team, setTeam] = useState([]);

  const lines = [
    "Line A",
    "Line B",
    "Line C",
    "Line D",
    "Shirataki",
    "Juten",
    "1Gal",
    "Fryer",
    "Multivac",
    "Building",
    "Production",
    "SQF",
    "Okara",
    "Recieving",
    "Soaking",
    "Casing",
    "Other",
  ];

  const machines = [
    "Silo",
    "Scale unit",
    "Conveyor",
    "Grinder",
    "Cooker",
    "surge Tank",
    "Separator",
    "Turn Table",
    "Steam Tunnel",
    "Morikomi",
    "Traverser",
    "Press Machine",
    "Alkali CV",
    "Pasteurizer",
    "Automation",
    "Topia",
    "Scal",
    "DPX",
    "Boil&cool",
    "Metal Detector",
    "Taper Machine",
    "Packing Machine",
    "Taper Machine",
    "Boiler",
    "Compressor",
    "Chiller",
    "Cooling tower",
    "HVAC",
    "Cooler",
    "Other",
  ];

  // ✅ Load technicians from backend Team list
  useEffect(() => {
    const loadTeam = async () => {
      try {
        const res = await api.get("/api/team");
        setTeam(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("❌ Error fetching team members", err);
        setTeam([]);
      }
    };
    loadTeam();
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (
      !formData.date ||
      !formData.line ||
      !formData.machine ||
      !formData.task ||
      !formData.lead_time ||
      !formData.assignee
    ) {
      alert("❌ Please fill in all required fields");
      return;
    }

    try {
      await api.post("/api/requests", formData);
      alert("✅ Request submitted to manager!");
      navigate("/requests");
    } catch (err) {
      console.error("❌ Error creating request", err);

      if (!err.response) {
        alert(`❌ Network/Server error:\n${err.message}`);
        return;
      }

      const msg =
        err.response?.data?.error ||
        err.response?.data?.message ||
        `HTTP ${err.response.status}`;

      alert(`❌ Failed to submit request: ${msg}`);
    }
  };

  return (
    <div className="main-content">
      <h1>➕ New Work Order Request</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Date:</label>
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Line:</label>
          <select
            name="line"
            value={formData.line}
            onChange={handleChange}
            required
          >
            <option value="">Select Line</option>
            {lines.map((l) => (
              <option key={l} value={l}>
                {l}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Machine:</label>
          <select
            name="machine"
            value={formData.machine}
            onChange={handleChange}
            required
          >
            <option value="">Select Machine</option>
            {machines.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Task:</label>
          <textarea
            name="task"
            value={formData.task}
            onChange={handleChange}
            required
          ></textarea>
        </div>

        <div>
          <label>Lead Time:</label>
          <input
            type="date"
            name="lead_time"
            value={formData.lead_time}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Assignee:</label>
          <select
            name="assignee"
            value={formData.assignee}
            onChange={handleChange}
            required
          >
            <option value="">Select Technician</option>

            {team.length === 0 ? (
              <option value="" disabled>
                (No technicians found — add in Team page)
              </option>
            ) : (
              team.map((t) => (
                <option key={t.id} value={t.full_name}>
                  {t.full_name}
                </option>
              ))
            )}
          </select>
        </div>

        <div>
          <label>Scheduled Date:</label>
          <input
            type="date"
            name="scheduled_date"
            value={formData.scheduled_date}
            onChange={handleChange}
          />
        </div>

        <br />
        <button type="submit">Submit Request</button>
      </form>
    </div>
  );
}

export default RequestForm;
